var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_2953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.625 12.5943C20.625 12.3457 20.7238 12.1072 20.8996 11.9314C21.0754 11.7556 21.3139 11.6568 21.5625 11.6568H23.4375C23.6861 11.6568 23.9246 11.7556 24.1004 11.9314C24.2762 12.1072 24.375 12.3457 24.375 12.5943V14.4693C24.375 14.7179 24.2762 14.9564 24.1004 15.1322C23.9246 15.308 23.6861 15.4068 23.4375 15.4068H21.5625C21.3139 15.4068 21.0754 15.308 20.8996 15.1322C20.7238 14.9564 20.625 14.7179 20.625 14.4693V12.5943Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 0.406738C6.81114 0.406738 7.0496 0.50551 7.22541 0.681326C7.40123 0.857141 7.5 1.0956 7.5 1.34424V2.28174H22.5V1.34424C22.5 1.0956 22.5988 0.857141 22.7746 0.681326C22.9504 0.50551 23.1889 0.406738 23.4375 0.406738C23.6861 0.406738 23.9246 0.50551 24.1004 0.681326C24.2762 0.857141 24.375 1.0956 24.375 1.34424V2.28174H26.25C27.2446 2.28174 28.1984 2.67683 28.9016 3.38009C29.6049 4.08335 30 5.03718 30 6.03174V26.6567C30 27.6513 29.6049 28.6051 28.9016 29.3084C28.1984 30.0117 27.2446 30.4067 26.25 30.4067H3.75C2.75544 30.4067 1.80161 30.0117 1.09835 29.3084C0.395088 28.6051 0 27.6513 0 26.6567V6.03174C0 5.03718 0.395088 4.08335 1.09835 3.38009C1.80161 2.67683 2.75544 2.28174 3.75 2.28174H5.625V1.34424C5.625 1.0956 5.72377 0.857141 5.89959 0.681326C6.0754 0.50551 6.31386 0.406738 6.5625 0.406738V0.406738ZM1.875 7.90674V26.6567C1.875 27.154 2.07254 27.6309 2.42417 27.9826C2.77581 28.3342 3.25272 28.5317 3.75 28.5317H26.25C26.7473 28.5317 27.2242 28.3342 27.5758 27.9826C27.9275 27.6309 28.125 27.154 28.125 26.6567V7.90674H1.875Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_2953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.406738)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICalendar);
export default __webpack_public_path__ + "static/media/iCalendar.fc4c182653d7d4c417bf3245a8ca89a5.svg";
export { ForwardRef as ReactComponent };